enum USER_TYPE {
  STAFF = "STAFF",
  CUSTOMER = "CUSTOMER",
}

export default USER_TYPE
